import { FileDropzone } from 'components'
import Flex from 'components/priority/Flex/Flex'
import { IMAGE_MIME_WILDCARD } from '@messenger/consts'

export const DropzoneDrawer = () => {
  return (
    <>
      <Flex column align="center">
        <FileDropzone
          text="Drag and drop case images here"
          onDrop={(files) => console.log(files)}
          fileTypes={[IMAGE_MIME_WILDCARD]}
          allowMultiple
        />
      </Flex>
    </>
  )
}

export default DropzoneDrawer
